import { useEffect } from "react";
import { useRouteError } from "react-router";
import { captureError } from "@utils/analytics.ts";
import { isChunkLoadError } from "@utils/chunkReload.ts";
import { ChunkErrorFallback } from "../ChunkErrorFallback/ChunkErrorFallback.tsx";

export const AppErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error(error);
    // Same rationale as AppRouterError: chunk load errors are infra/deploy noise, not app bugs.
    if (!isChunkLoadError(error)) {
      captureError("React error boundary", error);
    }
  }, [error]);

  if (isChunkLoadError(error)) {
    return <ChunkErrorFallback error={error} />;
  }

  const message =
    error instanceof Error ? error.message : JSON.stringify(error, null, 4);
  return (
    <div>
      Error
      <pre>{message}</pre>
    </div>
  );
};
